import styled from '@emotion/styled';

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.75em;
`;

export { SpinnerWrapper };
